module.exports = __webpack_public_path__ + "img/game_logo1.557a1f6d.png";